/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Dyna ERP API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HeaderPresetCreate,
  HeaderPresetDetail,
  HeaderPresetResponse,
  HeaderPresetUpdate,
  ListPhotoReportHeaderPresetsParams,
  PaginatedResponseHeaderPresetResponse
} from '../model';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Header Presets Endpoint
 */
export const listPhotoReportHeaderPresets = (
    params?: ListPhotoReportHeaderPresetsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedResponseHeaderPresetResponse>(
      {url: `/photo-report-header-presets/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPhotoReportHeaderPresetsQueryKey = (params?: ListPhotoReportHeaderPresetsParams,) => {
    return [
    `/photo-report-header-presets/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPhotoReportHeaderPresetsQueryOptions = <TData = Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError = unknown>(params?: ListPhotoReportHeaderPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPhotoReportHeaderPresetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>> = ({ signal }) => listPhotoReportHeaderPresets(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPhotoReportHeaderPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>>
export type ListPhotoReportHeaderPresetsQueryError = unknown


export function useListPhotoReportHeaderPresets<TData = Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError = unknown>(
 params: undefined |  ListPhotoReportHeaderPresetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>,
          TError,
          Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPhotoReportHeaderPresets<TData = Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError = unknown>(
 params?: ListPhotoReportHeaderPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>,
          TError,
          Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPhotoReportHeaderPresets<TData = Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError = unknown>(
 params?: ListPhotoReportHeaderPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Header Presets Endpoint
 */

export function useListPhotoReportHeaderPresets<TData = Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError = unknown>(
 params?: ListPhotoReportHeaderPresetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportHeaderPresets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPhotoReportHeaderPresetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create Header Preset Endpoint
 */
export const createPhotoReportHeaderPreset = (
    headerPresetCreate: HeaderPresetCreate,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<HeaderPresetResponse>(
      {url: `/photo-report-header-presets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: headerPresetCreate, signal
    },
      options);
    }




export const getCreatePhotoReportHeaderPresetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhotoReportHeaderPreset>>, TError,{data: HeaderPresetCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPhotoReportHeaderPreset>>, TError,{data: HeaderPresetCreate}, TContext> => {

const mutationKey = ['createPhotoReportHeaderPreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPhotoReportHeaderPreset>>, {data: HeaderPresetCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPhotoReportHeaderPreset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePhotoReportHeaderPresetMutationResult = NonNullable<Awaited<ReturnType<typeof createPhotoReportHeaderPreset>>>
    export type CreatePhotoReportHeaderPresetMutationBody = HeaderPresetCreate
    export type CreatePhotoReportHeaderPresetMutationError = unknown

    /**
 * @summary Create Header Preset Endpoint
 */
export const useCreatePhotoReportHeaderPreset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhotoReportHeaderPreset>>, TError,{data: HeaderPresetCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPhotoReportHeaderPreset>>,
        TError,
        {data: HeaderPresetCreate},
        TContext
      > => {
      return useMutation(getCreatePhotoReportHeaderPresetMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Header Preset Endpoint
 */
export const getPhotoReportHeaderPreset = (
    presetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<HeaderPresetDetail>(
      {url: `/photo-report-header-presets/${presetId}/`, method: 'GET', signal
    },
      options);
    }




export const getGetPhotoReportHeaderPresetQueryKey = (presetId: string,) => {
    return [
    `/photo-report-header-presets/${presetId}/`
    ] as const;
    }


export const getGetPhotoReportHeaderPresetQueryOptions = <TData = Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError = unknown>(presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPhotoReportHeaderPresetQueryKey(presetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>> = ({ signal }) => getPhotoReportHeaderPreset(presetId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: presetId !== null && presetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPhotoReportHeaderPresetQueryResult = NonNullable<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>>
export type GetPhotoReportHeaderPresetQueryError = unknown


export function useGetPhotoReportHeaderPreset<TData = Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError = unknown>(
 presetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>,
          TError,
          Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhotoReportHeaderPreset<TData = Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError = unknown>(
 presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>,
          TError,
          Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhotoReportHeaderPreset<TData = Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError = unknown>(
 presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Header Preset Endpoint
 */

export function useGetPhotoReportHeaderPreset<TData = Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError = unknown>(
 presetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportHeaderPreset>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPhotoReportHeaderPresetQueryOptions(presetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update Header Preset Endpoint
 */
export const updatePhotoReportHeaderPreset = (
    presetId: string,
    headerPresetUpdate: HeaderPresetUpdate,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<HeaderPresetResponse>(
      {url: `/photo-report-header-presets/${presetId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: headerPresetUpdate, signal
    },
      options);
    }




export const getUpdatePhotoReportHeaderPresetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePhotoReportHeaderPreset>>, TError,{presetId: string;data: HeaderPresetUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePhotoReportHeaderPreset>>, TError,{presetId: string;data: HeaderPresetUpdate}, TContext> => {

const mutationKey = ['updatePhotoReportHeaderPreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePhotoReportHeaderPreset>>, {presetId: string;data: HeaderPresetUpdate}> = (props) => {
          const {presetId,data} = props ?? {};

          return  updatePhotoReportHeaderPreset(presetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePhotoReportHeaderPresetMutationResult = NonNullable<Awaited<ReturnType<typeof updatePhotoReportHeaderPreset>>>
    export type UpdatePhotoReportHeaderPresetMutationBody = HeaderPresetUpdate
    export type UpdatePhotoReportHeaderPresetMutationError = unknown

    /**
 * @summary Update Header Preset Endpoint
 */
export const useUpdatePhotoReportHeaderPreset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePhotoReportHeaderPreset>>, TError,{presetId: string;data: HeaderPresetUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePhotoReportHeaderPreset>>,
        TError,
        {presetId: string;data: HeaderPresetUpdate},
        TContext
      > => {
      return useMutation(getUpdatePhotoReportHeaderPresetMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Header Preset Endpoint
 */
export const deletePhotoReportHeaderPreset = (
    presetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/photo-report-header-presets/${presetId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePhotoReportHeaderPresetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhotoReportHeaderPreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePhotoReportHeaderPreset>>, TError,{presetId: string}, TContext> => {

const mutationKey = ['deletePhotoReportHeaderPreset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePhotoReportHeaderPreset>>, {presetId: string}> = (props) => {
          const {presetId} = props ?? {};

          return  deletePhotoReportHeaderPreset(presetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePhotoReportHeaderPresetMutationResult = NonNullable<Awaited<ReturnType<typeof deletePhotoReportHeaderPreset>>>

    export type DeletePhotoReportHeaderPresetMutationError = unknown

    /**
 * @summary Delete Header Preset Endpoint
 */
export const useDeletePhotoReportHeaderPreset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhotoReportHeaderPreset>>, TError,{presetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePhotoReportHeaderPreset>>,
        TError,
        {presetId: string},
        TContext
      > => {
      return useMutation(getDeletePhotoReportHeaderPresetMutationOptions(options), queryClient);
    }
